import React from 'react'
import Calculador from '../components/Calculador'

const calendario = () => {
  return (
    <Calculador />
  )
}

export default calendario